import {ArticleDto} from "../article.dto";
import {VatRate} from "../../../libs/enum/vat-rate.enum";
import {ItemUnit} from "../../../libs/enum/item-unit.enum";

export class InvoiceArticleDto {

  public id!: string;
  public articleId: string | undefined;
  // mapping: number
  public articleNumber: number | undefined;
  public name!: string;
  public unit!: ItemUnit;
  public sellingPriceNet!: number;
  public purchasingPriceNet: number | undefined;
  public grossAmount!: number;
  public readonly vatAmount!: number;
  public finalNetAmount!: number;
  public finalGrossAmount!: number;
  public readonly finalVatAmount!: number;
  public currencyCode!: string;
  public vatRate!: VatRate;
  public readonly vatRateValue!: number;
  public oldPart!: boolean;
  public discountable!: boolean;

  constructor(init?: Partial<InvoiceArticleDto | ArticleDto> | undefined) {
    Object.assign(this, init);
  }

  public static fromArticle(article: ArticleDto): InvoiceArticleDto {
    const invoiceArticle = new InvoiceArticleDto(article);
    invoiceArticle.articleId = article.id;
    return invoiceArticle;
  }
}
